import { render, staticRenderFns } from "./grower_settlement_details.vue?vue&type=template&id=32d07560"
import script from "./grower_settlement_details.vue?vue&type=script&lang=js"
export * from "./grower_settlement_details.vue?vue&type=script&lang=js"
import style0 from "./grower_settlement_details.vue?vue&type=style&index=0&id=32d07560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports